export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_14.257edc0c.png";